import LayoutDefault from 'Components/LayoutDefault/LayoutDefault';
import React, { useEffect, useState } from 'react';
import Panel from 'Components/Panel/Panel';
import FilterItems from './FilterItems/FilterItems';
import PanelListDefault from 'Components/PanelListDefault/PanelListDefault';
import Registration from './Registration/Registration';
import User from './User/User';
import Client from './ClientVehicle/ClientVehicle';
import Service from './Service/Service';
import Company from './Company/Company';

const Configuration = () => {
    useEffect(() => {
        document.title = "Perichert | Configuração"
    }, [])

    const [registrationIdsSelected, setRegistrationIdsSelected] = useState([]);
    const [isActiveFilter, setIsActiveFilter] = useState('S');

    const mainStyle = {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        height: '100%'
    };

    function getItemPanel(defaultFilter) {
        if (!registrationIdsSelected || registrationIdsSelected.length != 1) {
            return null
        }

        switch (registrationIdsSelected[0]) {
            case 100:
                return (
                    <>
                        {defaultFilter}
                        <User
                            registrationIdsSelected={registrationIdsSelected}
                            isActiveFilter={isActiveFilter}
                        />
                    </>
                )
            case 101:
                return (
                    <>
                        {defaultFilter}
                        <Company
                            registrationIdsSelected={registrationIdsSelected}
                            isActiveFilter={isActiveFilter}
                        />
                    </>
                )
            case 102:
                return (
                    <>
                        <Client
                            registrationIdsSelected={registrationIdsSelected}
                            isActiveFilter={isActiveFilter}
                        />
                    </>
                )
            case 103:
                return (
                    <>
                        {defaultFilter}
                        <Service
                            registrationIdsSelected={registrationIdsSelected}
                            isActiveFilter={isActiveFilter}
                        />
                    </>
                )
            default: return null
        }
    }

    function getPanelRecords() {
        if (!registrationIdsSelected || registrationIdsSelected.length != 1) {
            return (
                <PanelListDefault isEmptyPanel={true} />
            )
        }

        const defaultFilter = (
            <FilterItems
                isActiveFilter={isActiveFilter}
                onUpdatesIsActiveFilter={setIsActiveFilter}
            />
        )

        return (
            <>
                {getItemPanel(defaultFilter)}
            </>
        )

    }

    const itemPanelStyle = {
        display: 'flex',
        flexDirection: 'column',
        marginLeft: '0px',
        maxWidth: isTwoPanels() ? 'calc(85% - 5px)' : 'calc(85% - 15px)',
        minWidth: isTwoPanels() ?  'calc(85% - 5px)' : 'calc(85% - 15px)'
    };

    function isTwoPanels() {
        return (registrationIdsSelected && [102].includes(registrationIdsSelected[0]));
    }

    return (
        <>
            <LayoutDefault>
                <Panel style={mainStyle}>
                    <Registration
                        registrationIdsSelected={registrationIdsSelected}
                        onUpdateRegistrationIdSelected={setRegistrationIdsSelected}
                    />
                    <Panel style={itemPanelStyle}
                        className={isTwoPanels() ? '' : 'main-modal'}>
                        {getPanelRecords()}
                    </Panel>
                </Panel>
            </LayoutDefault>
        </>
    );
};

export default Configuration;
